var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiveCode',{staticClass:"vbox flex main-start cross-start",attrs:{"sample":_vm.sample}})}
var staticRenderFns = []

export { render, staticRenderFns }